export default __webpack_public_path__ + "static/media/quikstart-4.46fc7d11.svg";